import { render, staticRenderFns } from "./TodayButton.vue?vue&type=template&id=5df1a516"
import script from "./TodayButton.vue?vue&type=script&lang=js"
export * from "./TodayButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports